import styled from '@emotion/styled'
import { breakpoint } from '../../../../__styling/style-functions/breakpoint'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../../__styling/themed-value'

export const StyledUpdateSchedule = styled('div')<{ isOpen: boolean }>(
    ({ isOpen, theme }) => {
        const triangleSize = '15px'

        return {
            position: 'absolute',
            opacity: isOpen ? 1 : 0,
            pointerEvents: isOpen ? 'auto' : 'none',
            bottom: themedValue(theme, {
                perthnow: 0,
                thewest: '-12%',
                fallback: 0,
            }),
            background: 'white',
            zIndex: 21,
            left: themedValue(theme, {
                perthnow: '-120%',
                thewest: 'unset',
                fallback: 'unset',
            }),
            right: themedValue(theme, {
                perthnow: 'unset',
                thewest: '0%',
                fallback: 'unset',
            }),
            padding: calcRem(40, 20, 24, 20),
            width: calcRem(345),
            color: 'black',
            boxShadow:
                '0px 4px 8px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.25), 0px 30px 24px -22px rgba(0, 0, 0, 0.15)',
            borderRadius: '16px',
            transition: 'opacity .3s ease',
            ['p:nth-child(2)']: {
                marginBottom: '0',
            },
            ['p:nth-child(3)']: {
                margin: '0',
            },
            ['h3']: {
                fontSize: themedValue(theme, {
                    perthnow: calcRem(30),
                    thewest: calcRem(22),
                    fallback: 'unset',
                }),
                lineHeight: themedValue(theme, {
                    perthnow: calcRem(31),
                    thewest: calcRem(23),
                    fallback: 'unset',
                }),
                fontFamily: theme.fonts.heading,
            },
            ['h3, ul']: {
                margin: 0,
                padding: 0,
            },
            li: {
                listStyleType: 'none',
            },
            ':after': {
                content: `""`,
                position: 'absolute',
                height: 0,
                width: 0,
                right: '-8px',
                top: themedValue(theme, {
                    perthnow: 'calc(89% - 125px)',
                    thewest: 'calc(94% - 125px)',
                    fallback: 'unset',
                }),
                borderTop: `${triangleSize} solid transparent`,
                borderBottom: `${triangleSize} solid transparent`,
                borderLeft: `${triangleSize} solid white`,
            },
            [breakpoint('sm')]: {
                right: themedValue(theme, {
                    perthnow: 'unset',
                    thewest: '19%',
                    fallback: 'unset',
                }),
                bottom: themedValue(theme, {
                    perthnow: 0,
                    thewest: '-36%',
                    fallback: 0,
                }),
                boxShadow:
                    '0px 4px 8px rgba(0, 0, 0, 0.15),0px 1px 2px rgba(0, 0, 0, 0.25),0px 30px 80px 40px rgba(0, 0, 0, 0.30)',
            },
            [breakpoint('md')]: {
                right: themedValue(theme, {
                    perthnow: 'unset',
                    thewest: '12%',
                    fallback: 'unset',
                }),
            },
        }
    },
)

export const StyledScheduleButton = styled('button')(({ theme }) => ({
    width: '100%',
    fontFamily: theme.fonts.heading,
    backgroundColor: theme.colors.actions.button.primary.background.default,
    fontSize: '14px',
    color: theme.colors.actions.button.primary.text.default,
    padding: themedValue(theme, {
        perthnow: calcRem(12, 0),
        thewest: calcRem(9, 0),
        fallback: 'unset',
    }),
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginTop: calcRem(30),
    border: 'none',
    cursor: 'pointer',
}))
